import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormModal, Loader, Text, Title, ContainerControlSite, Content, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';
import PendingChangesTable from './PendingChangesTable';
import { getPendingChanges, removePendingChange } from '../../../actions/admin';

class PendingChanges extends Component {
    state = {
        changes: null,
        changeToDelete: null
    };

    componentDidMount() {
        this._getChanges();
    }

    _getChanges = async () => {
        const changes = await this.props.dispatch(getPendingChanges());

        this.setState({
            changes: changes || [],
            changeToDelete: null
        });
    };

    _removeChange = async (changeID) => {
        if (changeID) {
            this.setState({
                changeToDelete: changeID
            });

            return;
        }

        const success = await this.props.dispatch(removePendingChange(this.state.changeToDelete));

        if (success) {
            this._getChanges();
        }
    };

    render() {
        const { whitelabel } = this.props;
        const styles = {
            contentBlock: {
                backgroundColor: Theme.colors.surface,
                boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
                display: 'block',
                margin: 'auto auto 30px auto',
                padding: '30px',
                position: 'relative',
                zIndex: Theme.zIndex.container
            }
        };

        if (!this.state.changes) {
            return <Loader whitelabel={ whitelabel } />;
        }

        return (
            <ContainerControlSite>
                <Content>
                    <Title title={ i18n.t(tokens.titles.pendingChanges) } />

                    <div style={ styles.contentBlock }>
                        <Text
                            medium
                            display="inline-block"
                            marginBottom={20}
                        >
                            { i18n.t(tokens.labels.admin.allPendingChanges) }
                        </Text>

                        {
                            this.state.changes.length === 0 ?
                                <Text large>{ i18n.t(tokens.labels.admin.noRecords) }</Text>
                                :
                                <PendingChangesTable records={ this.state.changes } removeChange={ this._removeChange } />
                        }
                    </div>
                </Content>

                <FormModal
                    open={this.state.changeToDelete !== null}
                    close={() => this.setState({ changeToDelete: null })}
                    title={ i18n.t(tokens.titles.areYouSure) }
                    disableBackdropClick
                    disableEscapeKeyDown
                    onSave={() => this._removeChange(false)}
                    saveButtonText={ i18n.t(tokens.buttons.removeChange) }
                    customContainerStyle={{ maxWidth: "500px" }}
                >
                    <Text medium margin="10px 0 0 0">
                        { i18n.t(tokens.labels.admin.scheduledChangeWillNotTakePlace) }
                    </Text>
                </FormModal>

                { this.props.loading && <Loader whitelabel={ whitelabel } /> }
            </ContainerControlSite>
        );
    }
}

PendingChanges.propTypes = {
    loading: PropTypes.bool,
    whitelabel: PropTypes.object
};

/**
 * @param state
 * @returns {{loading: boolean}}
 */
const mapStateToProps = (state) => ({
    loading: state.admin.loading,
    pendingChanges: state.admin.pendingChanges,
    whitelabel: state.whitelabel
});

export default (connect(mapStateToProps)(PendingChanges));